import { inquiryDetailCargos, tradeCondtion } from '@models/BookingInquiry';
import { contactFormLoose } from '@models/Contact';
import { country } from '@models/Country';
import { useTradingAgency } from '@models/TradingAgency';
import * as t from 'io-ts';
import { Props } from 'io-ts';
import * as h from 'tyrann-io';

type BookingInquiryLogTypeEntry<Tag extends string, P extends Props> = {
  tag: t.LiteralC<Tag>;
  id: t.NumberC;
  has_read: t.BooleanC;
  updated_at: t.StringC;
  created_at: t.StringC;
  before_value: t.TypeC<P>;
  after_value: t.TypeC<P>;
};

const makeBookingInquiryLog = <Tag extends string, P extends Props>(
  tag: Tag,
  value: P,
): BookingInquiryLogTypeEntry<Tag, P> => {
  return {
    tag: t.literal(tag),
    id: t.number,
    has_read: t.boolean,
    updated_at: t.string,
    created_at: t.string,
    before_value: t.type(value),
    after_value: t.type(value),
  };
};

export const bookingInquiryLog = h.taggedUnion([
  makeBookingInquiryLog('shipper', {
    shipper: contactFormLoose,
  }),
  makeBookingInquiryLog('consignee', {
    consignee: contactFormLoose,
  }),
  makeBookingInquiryLog('receiver', {
    receiver: contactFormLoose,
    preferred_arrival_date: t.string,
  }),
  makeBookingInquiryLog('cargos', {
    cargos: inquiryDetailCargos,
  }),
  makeBookingInquiryLog('miscInfo', {
    trade_condition: tradeCondtion,
    customer_no: t.string,
    use_trading_agency: useTradingAgency,
    trading_agency_payer: h.omittable(country),
    use_rcep: h.omittable(t.boolean),
  }),
  makeBookingInquiryLog('specialNote', {
    special_note: t.string,
  }),
]);

export const patchBookingInquiryLogs = t.type({
  has_read: t.boolean,
});

export type BookingInquiryLog = t.TypeOf<typeof bookingInquiryLog>;
